// extracted by mini-css-extract-plugin
export default {"root":"_3DkkSk37","main":"_2JmjmC7i"};